export default "{\n    \"replyPlaceholder\": \"Reply to note\",\n    \"sendNote\": \"Send Note\",\n    \"successMessage\": \"Note sent successfully\"\n}\n"